// @flow
import type { Query } from "common/graphql/types"
import gql from "graphql-tag"
import type { SubscriptionType } from "../types"

export const listSubscriptionTypes: Query<{data: SubscriptionType[]}> = {
  gql: gql`
    query listSubscriptionTypes {
      subscription {
        listTypes(filter: { targetRole: user }) {
          data {
            id
            slug
          }
        }
      }
    }
  `,
  selector: ["subscription", "listTypes", "data"],
}



// WEBPACK FOOTER //
// ./src/data/subscriptions/graphql/queries.js